import React, { useEffect, useRef, useState } from "react";
import { Button, DotLoading, Image, NavBar, Toast } from "antd-mobile";
import Splash from "./screens/Splash";
import GameCreate from "./screens/Create";
import GameHistoryList from "./screens/List";

import historyIcon from '../src/assets/history_icon.png'

import Storage, { STORE_KEYS } from "./common/Storage";
import LoadingView from "./components/LoadingView";
import Home from "./screens/Home";
import { DEV_MODE } from "./common/Constants";


export enum APPLICATION_SCREEN {
  SPLASH,
  HOME,
}

export interface IExtraData {
  historyId?: string,
  viewHoroscrope?: {
    name: string;
    icon: string;
  }
}

export const TESTING = false

export interface ISwitchScreenAction {
  setScreen: (screen: APPLICATION_SCREEN, data?: IExtraData) => void;
  data?: IExtraData
}

export default function App() {
  

  const renderRightIcons = () => {
    return (
      <div style={{marginRight: 16, justifyContent: 'right', textAlign: 'right'}}>
        {/* {showHistory && <Image src={historyIcon} width={24} height={24} onClick={()=> {
        
      }} />} */}
      </div>
    )
  }
  

  const [currentScreen, setCurrentScreen] = useState<APPLICATION_SCREEN>(DEV_MODE ? APPLICATION_SCREEN.HOME : APPLICATION_SCREEN.SPLASH)
  const [loggedIn, setLoggedIn] = useState(true)
  const [extraData, setExtraData] = useState<IExtraData|undefined>({})
  const processedLogin = useRef(false)
  const [showHistory, setShowHistory] = useState(false)
  const configured = useRef(false)


  const navigateScreen = (screen: APPLICATION_SCREEN, data?: IExtraData) => {
    console.log('navigate screen ', screen, ' with data:', data)
    setCurrentScreen(screen)
    setExtraData(data)
  }

  useEffect(()=> {
    let configuredValue = Storage.get(`${STORE_KEYS.CONFIGURED}`)
    configured.current = configuredValue
    if (TESTING) {
      configuredValue = 'okhihi'
    }
    if (!configured) {
    //   loginApp()
    } else {
      setLoggedIn(true)
    }
    window.setTimeout(()=> {
      setShowHistory(true)
    }, 2000)
  }, [])


  // const query = new URLSearchParams(location.search);
  // const token = query.get('token')
  // if (token && processedLogin.current === false && !configured.current) {
  //   processedLogin.current = true
  //   Storage.set(`${STORE_KEYS.CONFIGURED}`, true)
  //   processToken(token)
  // }


  if (!loggedIn) {
    return <LoadingView />
  }

  return (
    <div className="App">
      {/* <div style={{position: 'absolute', right: 48, top: 16}}>{renderRightIcons()}</div> */}
      {currentScreen == APPLICATION_SCREEN.SPLASH && <Splash setScreen={navigateScreen} data={extraData}/>}
      {currentScreen == APPLICATION_SCREEN.HOME && <Home setScreen={navigateScreen} data={extraData}/>}
    </div>
  );
}
